import { Handle } from "@xyflow/react";
import { IconButton } from "@mui/material";
import CloseIcon from "../../../../assets/closeIcon.svg";
import HangupIcon from "../../../../assets/phone-x.svg";

export default function HangupNode({ data, id, selected }) {
	return (
		<div style={{ position: "relative" }}>
			<div style={{
				display: "inline-block",
				borderRadius: 8,
				padding: selected ? 4 : 0,
				boxShadow: selected ? "0px 0px 3.01px 3.01px #34CB65, 0px 0px 0px 1.5px #FFFFFF" : "0 0 0 0 #fff",
				transition: "box-shadow 0.3s, padding 0.3s, border 0.3s",
				backgroundColor: "transparent"
		    }}>
				<div style={{ ...localStyles.container, display: "flex", flexDirection: "column" }}>
					<div style={{ backgroundColor: "#FF4D4F", height: "6px", borderTopLeftRadius: "8px", borderTopRightRadius: "8px" }}></div>

					<div style={{ display: "flex", alignItems: "center", padding: 12, gap: 6 }}>
						<div style={{ width: 28, height: 28, borderRadius: "50%", backgroundColor: "#FFE3E1", display: "flex", alignItems: "center", justifyContent: "center" }}>
							<img src={HangupIcon} alt="Hang Up" style={localStyles.img} />
						</div>
						<div className="t7 nc-gray-900 medium-font" style={{textDecoration: selected ? "underline" : "none"}}>Hang Up</div>
					</div>

					<div style={{ padding: 12, borderTop: "1px solid #E0E0E0" }}>
						<div className="t7 nc-gray-900 medium-font">Disconnect call</div>
					</div>

				</div>
				<Handle type="target" position="top" style={localStyles.handle} />
				<IconButton disabled={!selected} onClick={data.onDelete} style={{ position: "absolute", top: 20, right: 10 }}>
					<img src={CloseIcon} alt="Close" style={{ width: "16px", height: "16px" }} />
				</IconButton>
			</div>
		</div>
	)
}

const nodeDimensions = { width: "352px" };
const localStyles = {
	img: {
		width: 16,
		height: 16,
	},
	container: {
		width: nodeDimensions.width,
		border: "1px solid #E0E0E0",
		borderRadius: 8,
		backgroundColor: "#fff"
	},
	handle: {
		background: "#555" },
}